/** Page hero copy — avoids repeating sidebar nav labels three times */
export const ADMIN_TAB_PAGE_META = {
  overview: {
    title: 'Performance at a glance',
    subtitle: 'Fleet, revenue, compliance and live signals in one view.',
  },
  machines: {
    title: 'Fleet registry',
    subtitle: 'Status, fuel levels and deployment for every machine.',
  },
  bookings: {
    title: 'Booking pipeline',
    subtitle: 'Grouped by month and day with owner approval state.',
  },
  clients: {
    title: 'Client directory',
    subtitle: 'Accounts, GSTIN and booking history.',
  },
  owners: {
    title: 'Machine owners',
    subtitle: 'Partner accounts linked to your fleet.',
  },
  operators: {
    title: 'Field operators',
    subtitle: 'Assigned operators and contact details.',
  },
  wallet: {
    title: 'Billing & wallets',
    subtitle: 'Reconciliation snapshot and client wallet balances.',
  },
  approvals: {
    title: 'Pending sign-ups',
    subtitle: 'Approve clients, machine registrations, wallet top-ups and payouts.',
  },
  dlq: {
    title: 'Failed job queue',
    subtitle: 'Retry dead-letter items from WhatsApp, email and alerts.',
  },
  audit: {
    title: 'Security & audit trail',
    subtitle: 'Login, admin actions and forensic filters.',
  },
  reports: {
    title: 'Financial reconciliation',
    subtitle: 'Transaction ledger, filters, export and internal PDF.',
  },
  surveys: {
    title: 'Survey responses',
    subtitle: 'Field survey data, hot leads, pain ratings and CSV export.',
  },
  surveyReview: {
    title: 'Survey payment review',
    subtitle: 'Approve or reject freelancer submissions before payout (₹30 per approved form).',
  },
  surveyPayout: {
    title: 'Payout summary',
    subtitle: 'Freelancer-wise payable totals, rate setting, CSV export, and payout locking.',
  },
  surveyQr: {
    title: 'Freelancer registration & approval',
    subtitle: 'Approve applications, assign ID codes, and print survey QR cards for the field team.',
  },
  iot: {
    title: 'Device telemetry',
    subtitle: 'GPS, fuel sensors, dashcam and ignition status.',
  },
};

const ADMIN_TAB_I18N = {
  surveys: { titleKey: 'adminSurveyPageTitle', subtitleKey: 'adminSurveyPageSubtitle' },
  surveyReview: { titleKey: 'adminSurveyReviewPageTitle', subtitleKey: 'adminSurveyReviewPageSubtitle' },
  surveyPayout: { titleKey: 'adminSurveyPayoutPageTitle', subtitleKey: 'adminSurveyPayoutPageSubtitle' },
  surveyQr: { titleKey: 'adminSurveyQrPageTitle', subtitleKey: 'adminSurveyQrPageSubtitle' },
};

export function getAdminTabPageMeta(activeTab, fallbackLabel = 'Dashboard', t = null) {
  const i18n = ADMIN_TAB_I18N[activeTab];
  if (t && i18n) {
    return {
      title: t(i18n.titleKey),
      subtitle: t(i18n.subtitleKey),
    };
  }
  return ADMIN_TAB_PAGE_META[activeTab] || {
    title: fallbackLabel,
    subtitle: 'Executive command center for Development Express.',
  };
}
